import { render, staticRenderFns } from "./WelcomingPage.vue?vue&type=template&id=32be42ce&scoped=true&"
import script from "./WelcomingPage.vue?vue&type=script&lang=js&"
export * from "./WelcomingPage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomingPage.vue?vue&type=style&index=0&id=32be42ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be42ce",
  null
  
)

export default component.exports